import React from 'react'
import * as  C from "../componentsM/index"


const TheArts = () => {
    return (
        <>

            <C.Hero title={"GROUP 6: THE ARTS"}
                image={"/hero/12.jpg"} />


            <section className='p-4 md:p-24'>

                <div className='flex flex-col gap-5'>
                    <p>The different arts are an integral part of everyday life, permeating all levels of human creativity, expression, communication and understanding.</p>


                    <p>Subjects currently offered:</p>

                    <h1 className='text-xl md:text-3xl font-bold text-myBlue'>Visual Arts (SL & HL):</h1>

                    <p>This course encourages students to challenge their own creative and cultural expectations and boundaries. It is a thought-provoking course in which students develop analytical skills in problem-solving and divergent thinking, while working towards technical proficiency and confidence as art-makers.</p>


                    <p>The course is designed in such a way that students learn and explore the interdependent troika of Context (perspectives, theories and cultures), Methods (various art making practices) and Communicating (curatorial methods and practices) of visual art. They are also expected to engage in, experiment with and critically reflect upon a wide range of contemporary practices and media.</p>




                </div>
            </section>

        </>

    )
}

export default TheArts